import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { DateTime } from "luxon";
import { ACTIONS, ARQUIVO_OFX_VALUES_DEFAULT, COLUMN_TYPE, convertKeysToCamelCase } from '../../../../utils/financialHelper';
import api from '../../../../service/api';
import FormImportarArquivoOFX from './FormImportarArquivoOFX';
import ImportarDialog from './ImportarDialog';
import useCrud from '../../../../hooks/useCrud';
import CrudTablePage from '../../../../components/Financial/CrudTablePage';
import Filter from '../../../../components/Filter';
import SelectBancos from "../../../../components/Financial/SelectBancos"


const ImportarArquivoOFX = () => {

  const headCells = [
    { key: 'routingNumber', field: 'routingNumber', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Banco' },
    { key: 'accountNumber', field: 'accountNumber', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Conta' },
    { key: 'balanceDate', field: 'balanceDate', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Emitido em' },
    { key: 'interval', field: 'interval', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Período' },
    { key: 'transactionsQty', field: 'transactionsQty', type: COLUMN_TYPE.NUMBER, alignRight: false, label: 'Transações' },
    { key: 'fileName', field: 'fileName', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Arquivo' },
    { key: 'actions', field: 'actions', type: COLUMN_TYPE.BUTTONS, alignRight: true, label: 'Ações' },
  ];

  const funcionalidade = 'Arquivo OFX';

  const [openImportar, setOpenImportar] = useState(false);
  const [arquivoSelecionado, setArquivoSelecionado] = useState('');
  const [filter, setFilter] = useState({
    initDate: DateTime.now().toISODate(),
    endDate: DateTime.now().toISODate(),
    bankCode: 0,
  });

  const ajustarCamposCustomizadosOfxFile = (ofx) => {
    const balanceDate = new Date(ofx.balanceDate);
    const interval = `${new Date(ofx.startDate).toLocaleDateString()} - ${new Date(ofx.endDate).toLocaleDateString()}`
    const transactionsQty = ofx.transactions.length;

    return {
      ...ofx,
      balanceDate: balanceDate.toLocaleDateString(),
      interval,
      transactionsQty,
      transactions: convertKeysToCamelCase(ofx.transactions)
    }
  }

  const fetchResponseProcessor = (response) => {
    let ofxFile = convertKeysToCamelCase(response);
    ofxFile = ofxFile.map((ofx) => (ajustarCamposCustomizadosOfxFile(ofx)));
    return ofxFile;
  }

  const handleCloseAdditional = () => {
    setOpenImportar(false);
  }

  const handleImportar = () => {
    setOpenImportar(true);
  }

  const handleUploadFile = async () => {
    if (!arquivoSelecionado) {
      toast.error('Selecione um arquivo OFX para importar.');
      return null;
    }

    const formData = new FormData();
    formData.append('ofx-file', arquivoSelecionado);

    try {
      const apiResponse = await api.post('/import-ofx', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'File-Name': 'ofx-file'
        },
      });

      return apiResponse.data;
      // return resp;
    } catch (error) {
      toast.error(`Erro ao enviar arquivo. Favor tentar novamente dentro de alguns instantes. Sinalize o suporte caso persista. Erro técnico: ${error} - ${error?.response?.data?.error}`);
    }

    return null;
  }

  const {
    action,
    buttonLabel,
    dadoFoiModificado,
    filterValue,
    isLoading,
    isLoadingSubmit,
    items: arquivosOFX,
    open,
    title,
    values,
    setAction,
    setButtonLabel,
    setDadoFoiModificado,
    setFilterValue,
    setItems: setArquivosOFX,
    setValues,
    handleClose,
    handleDelete,
    handleEdit,
    handleOpen,
    handleSubmit,
    handleView,
  } = useCrud(
    '/ofx',
    ARQUIVO_OFX_VALUES_DEFAULT,
    funcionalidade,
    'Importar',
    fetchResponseProcessor,
    handleCloseAdditional,
    handleUploadFile,
    ACTIONS.UPLOAD,
  );

  const FetchOFXData = (result) => {
    if (result.data?.data?.length > 0) {
      const resp = fetchResponseProcessor(result.data.data);
      // console.log(resp);
      setArquivosOFX(resp);
      return true;
    }
    return false;
  }

  const handleFilter = async () => {
    const result = await api.get(`/ofx/?
      initDate=${filter.initDate}
      &endDate=${filter.endDate}
      &bankCode=${filter.bankCode}`);

    if (FetchOFXData(result)) {
      return;
    }

    setArquivosOFX([{routingNumber : 'Nenhum dado encontrado!'}]);
  }

  const handleClear = async () => {
    setFilter({initDate: '', endDate: ''});
    const result = await api.get(`/ofx/`);

    FetchOFXData(result);
  };   

  const dialogAdicional = (
    <ImportarDialog
      open={openImportar}
      title={title}
      handleClose={() => { setOpenImportar(false); }}
      handleSubmit={handleSubmit}
      setArquivoSelecionado={setArquivoSelecionado}
      isLoadingSubmit={isLoadingSubmit}
    />
  )

  return (
    <>
    <Filter
        buttonStyle={{"height": "fit-content"}}
        clickFilter={handleFilter}
        clearFilter={handleClear}
    >
      <label>
          Data inicial:
          <input
          type="date"
          name="initDate"
          className="input-form"
          title='Data inicial'
          value={filter.initDate}
          onChange={(e) => setFilter({...filter, initDate: e.target.value})}
          />
      </label>

      <label>
          Data final:
          <input
          type="date"
          name="endDate"
          className="input-form"
          title='Data final'
          value={filter.endDate}
          onChange={(e) => setFilter({...filter, endDate: e.target.value})}
          />
      </label>

      <SelectBancos 
        banco={filter.bankCode} 
        isDelete={false} 
        width={false}
        handleClear={() => setFilter({...filter, bankCode: 0})}
        onChange={(e) => setFilter({...filter, bankCode: e.target.value})}/>
    </Filter>

    <CrudTablePage
      isLoading={isLoading}
      funcionalidade={funcionalidade}
      rows={arquivosOFX}
      setRows={setArquivosOFX}
      headCells={headCells}
      handleView={handleView}
      handleDelete={handleDelete}
      filterValue={filterValue}
      setFilterValue={setFilterValue}
      dadoFoiModificado={dadoFoiModificado}
      setDadoFoiModificado={setDadoFoiModificado}
      open={open}
      title={title}
      buttonLabel={buttonLabel}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      action={action}
      handleOpen={handleOpen}
      textoBotaoInicial='Importar OFX'
      onClickBotaoInicial={handleImportar}
      dialogAdicional={dialogAdicional}
    >
      <FormImportarArquivoOFX
        values={values}
        setValues={setValues}
        isLoadingSubmit={isLoadingSubmit}
      />
    </CrudTablePage>
    </>
  )
}

export default ImportarArquivoOFX;